// Central catalogue of user-facing toast copy. Single source of truth so the wording
// stays consistent (sentence case, no "successfully" filler) and can't drift across the
// ~30 screens again. Interpolated / backend-driven messages stay at their call sites.
export const MSG = {
  userAdded: "User added.",
  inviteSent: "Invitation sent. The user will get an email to set their password.",
  userUpdated: "User updated.",
  userDeleted: "User deleted.",
  adminAdded: "Admin added.",
  adminUpdated: "Admin updated.",
  adminDeleted: "Admin deleted.",
  approverAdded: "Approver added.",
  approverUpdated: "Approver updated.",
  approverDeleted: "Approver deleted.",
  superAdminAdded: "Super Admin added.",
  superAdminUpdated: "Super Admin updated.",
  superAdminDeleted: "Super Admin deleted.",
  roleChanged: "Role changed.",
  mediaApproved: "Media approved.",
  mediaRejected: "Media rejected.",
  mediaDeleted: "Media deleted.",
  mediaStatusUpdated: "Media status updated.",
  downloadRequestSubmitted: "Download request submitted.",
  shareEmailSent: "Share email sent.",
  dataUploaded: "Uploaded.",
  dataUpdated: "Updated.",
  filePublic: "File is now public.",
  tagUpdated: "Tag updated.",
  tagDeleted: "Tag deleted.",
  passwordUpdated: "Password updated.",
  resetLinkSent: "If this email is registered, a password reset link is on its way.",
  mfaReset: "MFA reset. The user will re-enroll on next login.",
  backOnline: "Back online — resuming uploads…",
  genericError: "Something went wrong. Please try again.",
  linksExpired: "This page has been open a long time. Refreshing it to reload the media…",
  couldNotProcess: "Sorry — we couldn’t process your request right now. Please try again later.",
  offline: "You’re offline.",
  offlineUploadPaused: "You’re offline. Uploads will resume when you’re back online.",
  nameRequired: "Please enter your name.",
  firstNameRequired: "Please enter your first name.",
  lastNameRequired: "Please enter your last name.",
  companyRequired: "Please select or enter your company.",
  passwordShort: "Password must be at least 6 characters.",
  emailRequired: "Please enter your email.",
  emailInvalid: "Please enter a valid email address.",
  passwordRequired: "Please enter your password.",
  confirmPasswordRequired: "Please confirm your password.",
  passwordMismatch: "Passwords don’t match.",
  mobileInvalid: "Please enter a valid mobile number.",
  countryRequired: "Please select a country code.",
  descriptionRequired: "Please enter a description.",
  tagNameRequired: "Please enter a tag name.",
  rejectReasonRequired: "Please describe the reason for rejection.",
  fillAllFields: "Please fill in all fields.",
  fillTitleDescription: "Please fill in the title and description.",
  selectFile: "Please select a file.",
  selectToApprove: "Please select at least one item to approve.",
  selectToReject: "Please select at least one item to reject.",
  noChanges: "No changes to save.",
  tagExists: "This tag already exists.",
  noValidFiles: "No valid files to upload.",
  signedUrlFailed: "Couldn’t generate an upload link. Please try again.",
  uploadFailed: "Upload failed. Check your connection and try again.",
  downloadFailed: "Download failed. Please try again.",
  downloadStarted: "Your download has started. Check your browser’s downloads.",
  requestFailed: "Couldn’t submit your request. Please try again.",
  loadProcessingFailed: "Couldn’t load processing videos.",
  loadThumbCountFailed: "Couldn’t load the thumbnail count.",
  retryIdsFailed: "Couldn’t fetch the items to retry.",
  retrySendFailed: "Couldn’t send the retry request.",
  retryFailed: "Retry request failed.",
  thumbGenFailed: "Thumbnail generation request failed.",
  resumeFailed: "Couldn’t resume — starting again…",
  loginFailed: "Login failed. Please try again.",
  signupFailed: "Sign-up failed. Please try again.",
  idpUpdateFailed: "User saved, but their sign-in details could not be updated. Please try again or contact support.",
  resetMfaFailed: "Couldn’t reset MFA. Please try again.",
  resetLinkFailed: "Couldn’t send the reset link. Please try again.",
  loadUserDetailsFailed: "Couldn’t load user details.",
  fullAccessFailed: "Couldn’t update full access. Please try again.",
  noChangesMade: "No changes to save.",
  selectFiles: "Please select at least one file.",
  selectTagsToReplace: "Please select the tag(s) to replace.",
  replaceTagNameRequired: "Please enter the replacement tag name.",
  searchTextRequired: "Please enter search text.",
  zipSkippedNoFormat: "Some approved assets were skipped: no downloadable format.",
  requestLeftTab: "Decision saved. The request moved to another status tab.",
  alreadyApprovedSelection: "Every selected asset is already approved.",
  alreadyRejectedSelection: "Every selected asset is already rejected.",
  endDateInvalid: "The end date must be on or after the start date.",
  noVideosToRetry: "No videos to retry.",
  loadUsersFailed: "Couldn’t load the user list.",
};
